package com.questions.model

import kotlinx.serialization.Contextual
import kotlinx.serialization.Serializable
import kotlin.collections.List

@Serializable
data class UserScore(var correct: Int, var wrong: Int, var user : String)